import l10n from "../lang/locallang";
import * as helpers from "../helpers";

export default function initDateRangeController() {
    const dateFacetBlock = document.querySelector('.facet-option-list.facet-type-dateRange');

    if (!dateFacetBlock) {
        return;
    }

    const facetName = dateFacetBlock.getAttribute('data-facet-name');

    const startDateInput = dateFacetBlock.querySelector(`#start_date_${facetName}`);
    const endDateInput = dateFacetBlock.querySelector(`#end_date_${facetName}`);
    const submitButton = dateFacetBlock.querySelector('button[type="submit"]');
    const facetUrlInput = dateFacetBlock.querySelector(`#${facetName}_url`);

    if (!startDateInput || !endDateInput || !submitButton || !facetUrlInput) {
        console.warn('DateRangeController required startDateInput, endDateInput, facetUrlInput and submit button. Please add them.');
        return;
    }

    const addError = (elem, errorMessage) => {
        const nodeError = elem.parentNode.querySelector('.error');

        const message = errorMessage || ` ${l10n.entryError}`;

        if (!nodeError) {
            const elemId = elem.getAttribute('id');

            if (!elemId) {
                console.error('This field has no id, it is required.');
            } else {
                const alertContainer = document.createElement('div');
                alertContainer.setAttribute('id', `${elemId}-relation`);
                alertContainer.classList.add('error');
                alertContainer.classList.add('parsley-errors-list');

                elem.setAttribute('aria-describedby', `${elemId}-relation`);

                helpers.insertAfter(alertContainer, elem);

                const alertP = document.createElement('p');
                alertP.classList.add('parsley-required');
                alertP.innerHTML = ` ${message}`;
                alertContainer.appendChild(alertP);
            }
        }
    };

    const sendRequest = () => {
        if (startDateInput.value !== '' && endDateInput.value !== '') {
            let url = facetUrlInput.value;
            const startDate = startDateInput.value.replace(/-/g, '');
            const endDate = endDateInput.value.replace(/-/g, '');

            url = url.replace(encodeURI('___FROM___'), `${startDate}0000`);
            url = url.replace(encodeURI('___TO___'), `${endDate}2359`);

            if (new Date(endDateInput.value) >= new Date(startDateInput.value)) {
                window.location.href = url;
            } else {
                addError(endDateInput, ` ${l10n.endDateError}`);
            }
        }
    };

    submitButton.addEventListener('click', (e) => {
        sendRequest();
    });
}
